import React, { useState, useEffect } from 'react';
import PreviewEmailView from '../view/PreviewEmailView';

import { createEditorStateWithText } from 'draft-js-plugins-editor';
import { EditorState, ContentState, convertFromHTML } from 'draft-js';
import { decorator } from '../HyperLink4TextEditor';

/* eslint-disable no-alert, no-template-curly-in-string */
const REPLACMENT_MAP = {
  '${formTitle}': 'Your form title will go here',
  '${firstName}': 'Jane ',
  '${lastName}': 'Doe',
  '${email}': 'jane.doe@example.com',
  '${info.firstName}': 'Jane ',
  '${info.lastName}': 'Doe',
  '${info.email}': 'jane.doe@example.com',
  '${sender.firstName}': 'John',
  '${sender.lastName}': 'Smith',
  '${sender.email}': 'john.smith@example.com',
  '${submitter.firstName}': 'Joe',
  '${submitter.lastName}': 'Clark',
  '${submitter.email}': 'joe.clark@example.com',
  '${list of submissions}':
    '</div><div><ul><li><a href="#"> Submission 1 </a></li><li><a href="#"> Submission 2 </a></li></ul></div><div>',
  '${adminSubmissionLink}': 'Direct link will go here',
  '${formUrlLink}': 'Your form link will go here',
  '${formUrlOnlyLink}': 'Your form link will go here',
  '${numberOfSubmissions}': '{number of submissions}',
  '${resetPasswordLink}': '<a href="#">Click here to set your password</a>',
  '${resetPasswordUrlHtml}': '<a href="#">Click here to set your password</a>',
  '${activateUrlHtml}': '<a href="#">Click here to activate your account</a>'
};

/**
 * Will return the source text after all place holders got replaced according to
 * the mapping provided.
 * Original source text will not be modified.
 *
 * @param {*} source - source text with place holders
 * @param {*} defaultMapping - default mapping (should be REPLACMENT_MAP)
 * @param {*} customMapping - additinal mapping for more dynamic place holders
 */
const replacePlaceHolders = (
  source = '',
  defaultMapping = {},
  customMapping = {},
  useItalic = true
) => {
  let mappedText = source;
  if (JSON.stringify(customMapping) !== '{}') {
    Object.keys(customMapping).forEach(key => {
      const regex = new RegExp('\\' + key, 'g'); // all place holders start with '$' - need to escape that
      if (useItalic) {
        mappedText = mappedText.replace(regex, `<i>${customMapping[key]}</i>`);
      } else {
        mappedText = mappedText.replace(regex, customMapping[key]);
      }
    });
  }

  Object.keys(defaultMapping).forEach(key => {
    const regex = new RegExp('\\' + key, 'g'); // all place holders start with '$' - need to escape that
    if (useItalic) {
      mappedText = mappedText.replace(regex, `<i>${defaultMapping[key]}</i>`);
    } else {
      mappedText = mappedText.replace(regex, defaultMapping[key]);
    }
  });

  return mappedText;
};

const PreviewEmailEngine = ({
  subject,
  body,
  customMapping = {},
  customCSS,
  customParsingFunc = b => b
}) => {
  const [editorState, setEditorState] = useState(
    createEditorStateWithText(
      customParsingFunc(
        replacePlaceHolders(body, REPLACMENT_MAP, customMapping)
      )
    )
  );

  useEffect(() => {
    if (body.length) {
      const hackedText = `<div><p> ${body
        .replace(/<\/p>/gi, '<br>')
        .replace(/<p>/gi, '')
        .replace(/<ins>/gi, '<u>')
        .replace(/<\/ins>/gi, '</u>')} </p></div>`;

      const mappedBody = customParsingFunc(
        replacePlaceHolders(hackedText, REPLACMENT_MAP, customMapping)
      );

      const blocksFromHTML = convertFromHTML(mappedBody);
      const content = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
      );
      setEditorState(EditorState.createWithContent(content, decorator));
    }
  }, [body]);

  const viewProps = {
    subject: replacePlaceHolders(subject, REPLACMENT_MAP, customMapping, false),
    editorState,
    customCSS
  };
  return <PreviewEmailView {...viewProps} />;
};

export default PreviewEmailEngine;
